/* 
Copyright© Celligence International, LLC - 2024
This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Fragment, memo } from 'react';
import Style from './../../css/LoanInfoHeaderModal.module.css';
import { Button } from '@mui/material';
import DefaultModal from './DefaultModal';
// import { useLoanContext } from '../../contexts/LoanContext';
import EnvelopeWithBox from '../../components/EnvelopeWithBox';
import ButtonBorderWrapper from '../../components/ButtonBorderWrapper';
import ButtonBorder from '../../components/ButtonBorder';

type LoanInfoHeaderModalPropsType = {
  open: boolean;
  handleClose: any;
  comments: any[];
  title: string;
  stateCollectionNotices: { title: string; requirements: string[] }[];
  stateLicensingNotices: { title: string; requirements: string[] }[];
  doNotCall: boolean;
  borrowerLocalTime: string;
  callLimitReached: boolean;
  naturalDisaster: boolean;
  naturalDisasterName: string;
  naturalDisasterDate: string;
};

const LoanInfoHeaderModal = memo((props: LoanInfoHeaderModalPropsType) => {
  return (
    <Fragment>
      <DefaultModal
        className={Style.section}
        open={props.open}
        content={
          <ButtonBorderWrapper className={Style.modalWrapper}>
            <EnvelopeWithBox blockName={'Important Notices'} className={Style.noticesEnvelope}>
              <div className={Style.modalContainer}>
                {(props.doNotCall || props.callLimitReached || props.naturalDisaster) && (
                  <>
                    <h2 className={Style.modalHeader}>Validation Messages</h2>
                    <ul className={Style.list}>
                      {props.doNotCall && (
                        <li key={'doNotCall'} className={Style.listItem}>
                          {props.borrowerLocalTime
                            ? `DO NOT CALL: Local time is ${props.borrowerLocalTime}`
                            : `DO NOT CALL: Local time is outside of calling hours`}
                        </li>
                      )}
                      {props.callLimitReached && (
                        <li key={'callLimitReached'} className={Style.listItem}>
                          The limit for outbound calls to be made in a week has been exhausted and no call attempt
                          should be made
                        </li>
                      )}
                      {props.naturalDisaster && (
                        <li key={'naturalDisaster'} className={Style.listItem}>
                          NATURAL DISASTER:&nbsp;{props.naturalDisasterName}&nbsp;{props.naturalDisasterDate}
                        </li>
                      )}
                    </ul>
                  </>
                )}
                {props.comments.length > 0 ? (
                  <>
                    <h2 className={Style.modalHeader}>Manager Comments</h2>
                    <ul className={Style.list}>
                      {props.comments.map((comment) => (
                        <li key={comment.commentCategoryDescription.substring(4)} className={Style.listItem}>
                          {comment.commentCategoryDescription.substring(4)}:&nbsp;{comment.text}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <></>
                )}
                {props.stateCollectionNotices.length > 0 ? (
                  props.stateCollectionNotices.map((notice, index) => (
                    <div key={index}>
                      <h2 className={Style.modalHeader}>{notice.title}</h2>
                      <ul className={Style.list}>
                        {notice.requirements.map((item, reqIndex) => (
                          <li key={reqIndex} className={Style.listItem}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))
                ) : (
                  <></>
                )}
                {props.stateLicensingNotices.length > 0 ? (
                  props.stateLicensingNotices.map((notice, index) => (
                    <div key={index}>
                      <h2 className={Style.modalHeader}>{notice.title}</h2>
                      <ul className={Style.list}>
                        {notice.requirements.map((item, reqIndex) => (
                          <li key={reqIndex} className={Style.listItem}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </div>
            </EnvelopeWithBox>
            <ButtonBorder disabled={false}>
              <Button type='button' onClick={props.handleClose} className={Style.button}>
                Close
              </Button>
            </ButtonBorder>
          </ButtonBorderWrapper>
        }
      />
    </Fragment>
  );
});

export default LoanInfoHeaderModal;
